import * as jwt from 'jsonwebtoken';

export interface UserRolesIds {
  userroleId: number;
  allowView: boolean;
  allowDraft: boolean;
  allowFinalize: boolean;
}
export interface JwtToken {
  userId: number;
  userName: String;
  userFullName: string;
  userTypeId: number;
  userRolesIds: UserRolesIds[];
  associatedId: number; // i.e. CollectorId, WasteReceptionPointId, or CollectionpointId
  JwtExpirationDate: Date;
  JwtIssueDate: Date;
}

const JWT_PRIVATE_KEY = 'MOTION$WASTEMNGMT';

export function adminDevToken(): string {
  const issueDate = new Date();
  const expireDate = new Date(issueDate.setHours(issueDate.getHours() + 1));

  const jwtObj: JwtToken = {
    userId: 1,
    userName: 'motion',
    userFullName: 'test user',
    userTypeId: 1,
    userRolesIds: [{ userroleId: 1, allowView: true, allowDraft: true, allowFinalize: true }],
    associatedId: 0,
    JwtExpirationDate: issueDate,
    JwtIssueDate: expireDate,
  };

  return encodeJwtToken(jwtObj);
}

export function encodeJwtToken(jwtObj: JwtToken): string {
  return jwt.sign(jwtObj, JWT_PRIVATE_KEY);
}

export function decodeJwtToken(tokenString: string): JwtToken {
  const decoded = jwt.verify(tokenString, JWT_PRIVATE_KEY) as any;
  const jwtToken: JwtToken = decoded;
  jwtToken.JwtExpirationDate = new Date(Date.parse(decoded.JwtExpirationDate));
  jwtToken.JwtIssueDate = new Date(Date.parse(decoded.JwtIssueDate));
  console.log('$$$$$ jwtToken', jwtToken);
  return jwtToken as JwtToken;
}
